<template>
    <div id="app">
        <ejs-tab id="element" ref='contractmanagementTab'>
            <e-tabitems>
                <e-tabitem :header='headerText1' :content='officeTemplate'></e-tabitem>
                <e-tabitem :header='headerText2' :content='clientCoordinatorTemplate'></e-tabitem>
                <e-tabitem :header='headerText3' :content='consultantTemplate'></e-tabitem>
                <e-tabitem :header='headerText4' :content='riskManagerTemplate'></e-tabitem>
                <e-tabitem :header='headerText5' :content='contractTypeTemplate'></e-tabitem>
            </e-tabitems>
        </ejs-tab>
    </div>
</template>
<script>
    import Vue from 'vue';
    import { TabPlugin } from '@syncfusion/ej2-vue-navigations';
    import officesForm from '@/views/administration/contractManagement/Office.vue';
    import contractTypeForm from '@/views/administration/ContractType.vue';
    import clientCoordinatorForm from '@/views/administration/contractManagement/ClientCoordinator.vue';
    import consultantForm from '@/views/administration/contractManagement/Consultant.vue';
    import riskManagerForm from '@/views/administration/contractManagement/RiskManager.vue';

    import { DatePickerComponent, CalendarComponent, DatePickerPlugin, CalendarPlugin } from '@syncfusion/ej2-vue-calendars';

    Vue.use(TabPlugin);
    Vue.use(TabPlugin);
    Vue.component(DatePickerPlugin.name, DatePickerComponent);
    Vue.component(CalendarPlugin.name, CalendarComponent);

    export default {
        name: 'app',
        data: function () {
            return {  
                headerText1: { text: 'Offices' },
                headerText2: { text: 'Client Coordinators' },
                headerText3: { text: 'Consultants' },
                headerText4: { text: 'Risk Managers' },
                headerText5: { text: 'Contract Type' },
                propsData: null,
                contractTypeTemplate: function () {
                    return {
                        template: {
                            extends: contractTypeForm
                        }
                    }
                },
                officeTemplate: function () {
                    return {
                        template: {
                            extends: officesForm
                        }
                    }
                },
                clientCoordinatorTemplate: function () {
                    return {
                        template: {
                            extends: clientCoordinatorForm
                        }
                    }
                },
                consultantTemplate: function () {
                    return {
                        template: {
                            extends: consultantForm
                        }
                    }
                },
                riskManagerTemplate: function () {
                    return {
                        template: {
                            extends: riskManagerForm
                        }
                    }
                }
            }
        },
        mounted: function () {
      
            if (!this.$store.state.permissions["Permissions.Offices.View"]) {
                this.$refs.contractmanagementTab.hideTab(0);
            }
            if (!this.$store.state.permissions["Permissions.ClientCoordinator.View"]) {
                this.$refs.contractmanagementTab.hideTab(1);
            }
            if (!this.$store.state.permissions["Permissions.Consultants.View"]) {
                this.$refs.contractmanagementTab.hideTab(2);
            }
            if (!this.$store.state.permissions["Permissions.RiskManager.View"]) {
                this.$refs.contractmanagementTab.hideTab(3);
            }
            if (!this.$store.state.permissions["Permissions.ContractTypes.View"]) {
                this.$refs.contractmanagementTab.hideTab(4);
            }
        },
    }
</script>

<style scope>
    .required-input.e-float-input.e-control-wrapper .e-float-text::after {
        content: '*';
        color: red;
        margin-left: 4px;
        font-weight: bold;
    }
</style>